export default "__VITE_ASSET__9e28ae15__"